import { Fetch } from '@inface-sdk/common';

/**
 * ALLtem의 리턴 방식이 HAL+JSON 형식이라 await 사용시 브라우저에서 다른 형식으로 리턴되어 추가래퍼 작성
 * @param {Frunction} requestFunc
 * @returns JSON
 */
function _getResponseToJSON(requestFunc) {
  return new Promise(function (resolve, reject) {
    try {
      requestFunc.catch(function (error) {
        reject(error);
      });
      requestFunc.then(function (result) {
        return result.json();
      })
      // eslint-disable-next-line no-unused-expressions
      .then(function (jsonRes) {
        !jsonRes || jsonRes.error ? reject(jsonRes) : resolve(jsonRes);
      }).catch(function (errorRes) {
        return reject(errorRes);
      });
    } catch (error) {
      console.error('INPAY Error ', error);
      reject(error);
    }
  });
}
var apiForWeb = {
  queryParams: function queryParams(_ref) {
    var _ref$param = _ref.param,
      param = _ref$param === void 0 ? {} : _ref$param;
    return Object.keys(param).map(function (key) {
      if (Array.isArray(param[key])) {
        return "".concat(key, "=").concat(param[key].join(','));
      }
      return "".concat(key, "=").concat(param[key]);
    }).join('&');
  },
  req: function req(_ref2) {
    var url = _ref2.url,
      method = _ref2.method,
      _ref2$body = _ref2.body,
      body = _ref2$body === void 0 ? {} : _ref2$body,
      _ref2$useQuery = _ref2.useQuery,
      useQuery = _ref2$useQuery === void 0 ? false : _ref2$useQuery,
      _ref2$header = _ref2.header,
      header = _ref2$header === void 0 ? {} : _ref2$header;
    if (useQuery || method === 'GET') {
      var query = this.queryParams(body);
      var fullUrl = query === '' ? url : "".concat(url, "?").concat(query);
      return _getResponseToJSON(Fetch(fullUrl, {
        method: method,
        headers: header
      }));
    }
    return _getResponseToJSON(Fetch(url, {
      method: method,
      body: body,
      headers: header
    }));
  }
};
export default apiForWeb;